import React, { FunctionComponent } from 'react';
import { Button, IButtonProps } from '../button/button';
import { Text, ITextProps } from '../text/text';
import styles from './two-color-section-with-image.module.scss';
import classNames from 'classnames/bind';

export interface ITwoColorSectionWithImageProps {
  image: {
    url: string;
    description: string;
  };
  button: IButtonProps[];
  header: ITextProps[];
  description: string;
  additionalMarginInColumn: string;
}

const cx = classNames.bind(styles);

export const TwoColorSectionWithImage: FunctionComponent<ITwoColorSectionWithImageProps> = ({
  button,
  image,
  header,
  description,
  additionalMarginInColumn
}) => {
  const containerClass = cx({
    marginSmallColumn: additionalMarginInColumn === 'small',
    marginMediumColumn: additionalMarginInColumn === 'medium',
    marginLargeColumn: additionalMarginInColumn === 'large',
    marginExtraLargeColumn: additionalMarginInColumn === 'extra_large'
  });

  return (
    <div className={`${containerClass} ${styles.container}`}>
      <div className={styles.topSection}>
        <div className={styles.headerWrapper}>
          <div className={styles.header}>
            {header.map((text: ITextProps, i: number) => (
              <Text {...text} key={i} />
            ))}
          </div>
        </div>
      </div>
      <div className={styles.bottomSection}>
        <div className={styles.bottomWrapper}>
          <div className={styles.imageWrapper}>
            <div className={styles.img}>
              <img src={image.url} alt={image.description} />
            </div>
          </div>
          <div className={styles.bottomDescription}>
            <div
              className={styles.richText}
              dangerouslySetInnerHTML={{ __html: description }}
            ></div>
            {button.map((b: IButtonProps, i: number) => (
              <Button {...b} key={i} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
